import { hasPermission, useSession } from '../hooks/useSession.tsx';
import { AdminUsage } from './usage/AdminUsage.tsx';
import { MemberUsage } from './usage/MemberUsage.tsx';

/**
 * `/usage` — permission fork only (epic #897 PR 6). Admins
 * (`org:usage:read`) get the org-wide analytics dashboard; members get
 * the self-scoped view. The two screens share the `pages/usage/`
 * formatters so their numbers cannot drift.
 */
export function Usage(): JSX.Element {
  const { user } = useSession();
  return hasPermission(user, 'org:usage:read') ? <AdminUsage /> : <MemberUsage />;
}
